export default __webpack_public_path__ + "static/media/gallery-wip-paint_00.34a52da7.jpg";